var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card mb-30",
      attrs: { id: "member-" + _vm.permitNumber, role: "button" },
      on: {
        mousedown: function($event) {
          return _vm.focusMapOnDietitian()
        }
      }
    },
    [
      _c("div", { staticClass: "card-body p-sm-30 p-3" }, [
        _c("h4", { staticClass: "name" }, [
          _c(
            "a",
            {
              staticClass: "text-primary",
              attrs: { href: "membre?permit_number=" + _vm.permitNumber }
            },
            [_vm._v(_vm._s(_vm.name))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-3 d-flex" }, [
          _c(
            "a",
            {
              staticClass: "phone",
              attrs: { href: "tel:+" + _vm.phoneNumber }
            },
            [_vm._v(_vm._s(_vm.phoneNumber))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row gx-2 align-items-end" }, [
          _c(
            "div",
            { staticClass: "col-10 d-flex flex-wrap" },
            [
              _vm._l(_vm.practices, function(area, index) {
                return _c(
                  "span",
                  { key: index, staticClass: "badge badge-sm bg-blue-70" },
                  [_vm._v(_vm._s(area))]
                )
              }),
              _vm._v(" "),
              Object.entries(_vm.areasPracticed).length > 4
                ? _c("span", { staticClass: "badge badge-sm bg-blue-70" }, [
                    _vm._v(
                      "+ " +
                        _vm._s(Object.entries(_vm.areasPracticed).length - 4)
                    )
                  ])
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-auto ms-auto text-primary d-flex" }, [
            _c(
              "a",
              {
                staticClass: "text-primary lh-1",
                attrs: { href: "membre?permit_number=" + _vm.permitNumber }
              },
              [_c("i", { staticClass: "ph-arrow-circle-right" })]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }